import { useId } from "react";

// Sprachen der Site-Umschalter (Navbar + Footer): Reihenfolge EN · EL · DE · RU · AR · HE,
// volle Namen. Bewusst lokal gehalten, damit der Umschalter eine eigene
// Reihenfolge/Beschriftung führen kann; setLang(code) bleibt der bestehende
// useLang()-Mechanismus. ar/he sind RTL (siehe config/market.js).
export const SITE_LANGS = [
  { code: "en", label: "English" },
  { code: "el", label: "Ελληνικά" },
  { code: "de", label: "Deutsch" },
  { code: "ru", label: "Русский" },
  { code: "ar", label: "العربية" },
  { code: "he", label: "עברית" },
  { code: "zh", label: "中文" },
];

// Erkennbare Inline-SVG-Flaggen. Emoji-Flaggen (🇩🇪 …) rendern auf Windows/Chrome
// nur als Buchstaben ("DE"), daher zeichnen wir sie selbst — überall konsistent.
export function Flag({ code, className }) {
  const rawId = useId();
  const id = "fl" + rawId.replace(/[^a-zA-Z0-9]/g, "");
  const cls = className || "w-5 h-3.5 rounded-[2px] overflow-hidden shrink-0 ring-1 ring-black/10";
  if (code === "en") {
    return (
      <svg viewBox="0 0 60 30" className={cls} aria-hidden="true">
        <clipPath id={id}><path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" /></clipPath>
        <rect width="60" height="30" fill="#012169" />
        <path d="M0,0 L60,30 M60,0 L0,30" stroke="#ffffff" strokeWidth="6" />
        <path d="M0,0 L60,30 M60,0 L0,30" clipPath={`url(#${id})`} stroke="#C8102E" strokeWidth="4" />
        <path d="M30,0 v30 M0,15 h60" stroke="#ffffff" strokeWidth="10" />
        <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
      </svg>
    );
  }
  if (code === "el") {
    // Griechenland: 9 Streifen (blau/weiß) + blaues Kanton mit weißem Kreuz.
    return (
      <svg viewBox="0 0 27 18" className={cls} aria-hidden="true">
        <rect width="27" height="18" fill="#0D5EAF" />
        {[1, 3, 5, 7].map((i) => (
          <rect key={i} y={i * 2} width="27" height="2" fill="#ffffff" />
        ))}
        <rect width="10" height="10" fill="#0D5EAF" />
        <rect x="4" width="2" height="10" fill="#ffffff" />
        <rect y="4" width="10" height="2" fill="#ffffff" />
      </svg>
    );
  }
  if (code === "de") {
    return (
      <svg viewBox="0 0 20 14" className={cls} aria-hidden="true">
        <rect width="20" height="14" fill="#000000" />
        <rect y="4.667" width="20" height="4.667" fill="#DD0000" />
        <rect y="9.333" width="20" height="4.667" fill="#FFCE00" />
      </svg>
    );
  }
  if (code === "ru") {
    return (
      <svg viewBox="0 0 20 14" className={cls} aria-hidden="true">
        <rect width="20" height="14" fill="#ffffff" />
        <rect y="4.667" width="20" height="4.667" fill="#0039A6" />
        <rect y="9.333" width="20" height="4.667" fill="#D52B1E" />
      </svg>
    );
  }
  if (code === "he") {
    // Israel: weiß mit zwei blauen Streifen + Davidstern (zwei Dreiecke).
    return (
      <svg viewBox="0 0 20 14" className={cls} aria-hidden="true">
        <rect width="20" height="14" fill="#ffffff" />
        <rect y="1.6" width="20" height="1.6" fill="#0038B8" />
        <rect y="10.8" width="20" height="1.6" fill="#0038B8" />
        <path d="M10 4 l1.73 3 h-3.46 z M10 10 l-1.73 -3 h3.46 z" fill="none" stroke="#0038B8" strokeWidth="0.6" />
      </svg>
    );
  }
  if (code === "zh") {
    // China: rot mit großem Stern + vier kleinen Sternen (vereinfacht als Punkte).
    return (
      <svg viewBox="0 0 20 14" className={cls} aria-hidden="true">
        <rect width="20" height="14" fill="#DE2910" />
        <path d="M3.4 2.2 l0.66 2.03 h2.13 l-1.72 1.25 l0.66 2.02 l-1.73 -1.25 l-1.72 1.25 l0.66 -2.02 l-1.72 -1.25 h2.13 z" fill="#FFDE00" />
        <circle cx="7.6" cy="1.9" r="0.55" fill="#FFDE00" />
        <circle cx="8.7" cy="3.4" r="0.55" fill="#FFDE00" />
        <circle cx="8.7" cy="5.4" r="0.55" fill="#FFDE00" />
        <circle cx="7.6" cy="6.9" r="0.55" fill="#FFDE00" />
      </svg>
    );
  }
  if (code === "ar") {
    // Keine eindeutige Länderflagge für „Arabisch" — neutrales Sprach-Badge.
    return (
      <svg viewBox="0 0 20 14" className={cls} aria-hidden="true">
        <rect width="20" height="14" fill="#0E7C61" />
        <text x="10" y="10.5" textAnchor="middle" fontSize="8" fill="#ffffff" fontFamily="serif">ع</text>
      </svg>
    );
  }
  return <span aria-hidden="true">🌐</span>;
}
